import { render, staticRenderFns } from "./terms.html?vue&type=template&id=1c5abaaa&scoped=true&"
import script from "./terms.js?vue&type=script&lang=js&"
export * from "./terms.js?vue&type=script&lang=js&"
import style0 from "./terms.scss?vue&type=style&index=0&id=1c5abaaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5abaaa",
  null
  
)

export default component.exports